import { render, staticRenderFns } from "./CityFilters.vue?vue&type=template&id=7cb60084&"
import script from "./CityFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CityFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb60084')) {
      api.createRecord('7cb60084', component.options)
    } else {
      api.reload('7cb60084', component.options)
    }
    module.hot.accept("./CityFilters.vue?vue&type=template&id=7cb60084&", function () {
      api.rerender('7cb60084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/CityFilters/CityFilters.vue"
export default component.exports